


























































import Vue from 'vue';
import api from '@/shared/api';
import { Incident } from '@/shared/api/types';
import TeenLookup from '@/components/TeenLookup.vue';
import Select1 from '@/components/Select1.vue';
import Auth from '@/shared/auth';

type Nullable<T> = {
  [P in keyof T]: Nullable<T[P]> | null;
};
type Option = {
  value: string | number;
  label: string;
};

interface Data {
  programOptions: Option[];
  selectedTeen: number | null;
  selectedProgram: number | null;
  incident: Nullable<Incident>;
}

interface Methods {
  fetchData: () => Promise<void>;
}

interface Computed {
  id: string;
  action: string;
  canEdit: boolean;
}

const defaultIncident: Nullable<Incident> = {
  SummerIncidentReportID: undefined,
  Concern: [],
  OtherConcern: null,
  Intervention: null,
  Description: null,
  FollowUp: null,
  InitialContactDate: null,
  InitialConversationDate: null,
  Teen: { personID: null, Person: { PersonID: null, FirstName: null, LastName: null, FullName: null } },
  TeenID: null,
  Staff: null,
  Season: null,
  EventSubTypeID: null,
  EventSubType: { EventSubTypeID: null, description: null }
};

export default Vue.extend<Data, Methods, Computed, {}>({
  data () {
    return {
      programOptions: [],
      selectedTeen: null,
      selectedProgram: null,
      incident: defaultIncident
    };
  },
  components: { TeenLookup, Select1 },
  computed: {
    id: function () {
      return this.$route.params.id;
    },
    action: function () {
      return this.$route.path.split('/')[2];
    },
    canEdit: function () {
      return Auth.canEdit();
    }
  },
  created () {
    this.fetchData();
  },
  watch: {
    $route: function () {
      this.selectedTeen = null;
      this.selectedProgram = null;
      this.incident = defaultIncident;
      this.fetchData();
    },
    selectedTeen: function () {
      this.incident.TeenID = this.selectedTeen;
    },
    selectedProgram: function () {
      this.incident.EventSubTypeID = this.selectedProgram;
    }
  },
  methods: {
    async fetchData () {
      if (this.id && this.incident && (!this.incident.TeenID || this.id !== this.incident.TeenID.toString())) {
        const incidentResponse = await api.getIncident(this.id);
        if (incidentResponse && incidentResponse.status === 200) {
          Object.assign(this.incident, incidentResponse.data);
        }
      }
      const programsResponse = await api.getSummerPrograms();
      if (programsResponse && programsResponse.status === 200) {
        this.programOptions = programsResponse.data.map(item => {
          return { label: item.description, value: item.EventSubTypeID };
        });
      }
    }
  }
});
